var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.5 2A1.5 1.5 0 0 1 16 3.5v13a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 1 14.5 2m-9 0A1.5 1.5 0 0 1 7 3.5v13a1.5 1.5 0 0 1-3 0v-13A1.5 1.5 0 0 1 5.5 2"
})));
export default SvgIconPause;